<template>
  <!-- ROOT -->
  <VDropdown
    theme="info-dropdown"
    placement="bottom-start"
    :triggers="['click']"
    :popperClass="rootMenuClass"
  >
    <!-- Label -->
    <button class="dropdown-label">
      <slot name="label" />
    </button>

    <!-- PROJECTS -->
    <template #popper>
      <div class="dropdown-menu">
        <VDropdown
          v-for="project in projects"
          :key="project.id"
          placement="right-start"
          :triggers="['click']"
          :popperClass="secondMenuClass"
          :skidding="-16"
        >
          <button class="menu-item">
            <slot
              name="project"
              :project="project"
            />
          </button>

          <template #popper>
            <div
              class="dropdown-menu rootMenuClass"
              :class="rootMenuClass"
            >
              <VDropdown
                v-for="team in project.teams"
                :key="team.id"
                placement="right-start"
                :popperClass="thirdMenuClass"
                :triggers="['click']"
                :skidding="-16"
              >
                <button class="menu-item team-item">
                  <slot
                    name="team"
                    :team="team"
                  />
                </button>

                <template #popper>
                  <div class="dropdown-menu">
                    <slot
                      name="sprint"
                      :sprints="team.sprints"
                    />
                  </div>
                </template>
              </VDropdown>
            </div>
          </template>
        </VDropdown>
        <BaseSubHeading
          v-if="!projects.length"
          size="large"
          weight="400"
          color="monochrome-07"
        >
          No Projects found
        </BaseSubHeading>
      </div>
    </template>
  </VDropdown>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

@Options({
  name: "MyWorkTripleDropdownTooltip"
})
export default class TripleDropdownTooltip extends Vue {
  @Prop({ required: true }) readonly projects!: any[]
  @Prop({ default: "" }) readonly rootMenuClass: string
  @Prop({ default: "" }) readonly secondMenuClass: string
  @Prop({ default: "" }) readonly thirdMenuClass: string
}
</script>

<style scoped lang="scss"></style>
